import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService, TmsWebBaseCommentService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class StockItemCommentService extends TmsWebBaseCommentService {
  constructor(protected httpService: HttpService) {
    super('StockItemComment', httpService);
  }
}
